export default {
	SubmitDeclaration: 'Nộp tờ khai',
	AddTaxPaper: 'Lập giấy nộp tiền',
	AddTaxPaperNowAcronym: 'Lập giấy nộp tiền nộp thay',
	Later: 'Để sau',
	VerifyButton: 'Xác thực',
	Cancel: 'Hủy bỏ',
	Confirm: 'Xác nhận',
	SelectCompany: 'Chọn công ty:',
	ViewProcedureHere: 'Bạn có thể xem lại quy trình ở đây',
	User: {
		ListTaxCode: 'Danh sách mã số thuế',
		Change: 'Thay đổi',
		UsageAgreement: 'Thỏa thuận sử dụng',
		PrivacyPolicy: 'Chính sách bảo vệ dữ liệu cá nhân',
		LogOut: 'Đăng xuất'
	},
	Verify: {
		AccuracyInfo: 'Xác thực thông tin',
		InputVerifyHasSend: type => `Nhập mã xác thực đã được gửi đến ${type == 2 ? 'số điện thoại' : 'email'}`,
		NotMyUser: type => `Đây không phải là ${type == 2 ? 'số điện thoại' : 'email'} của tôi`,
		VerifyCode: 'Mã xác thực',
		NotTakeCode: 'Không nhận được mã?',
		Resend: 'Gửi lại',
		PhoneNoneActive: 'Số điện thoại chưa xác thực',
		ActiveToLogin: (type, value) =>
			`Xác thực ngay để đăng nhập bằng ${type == 2 ? 'số điện thoại' : 'email'
			} <strong>${value}</strong> từ lần sau`,
		EmailNoneActive: 'Email chưa xác thực'
	},

	//Bo sung
	GuideOnline: 'Hướng dẫn sử dụng (F1)',
	StaffOnFaceBook: 'Nhân viên tư vấn số trên Facebook',
	CommunitySupport: 'Cộng đồng hỗ trợ miễn phí MISA',
	ForumSupportMisa: 'Diễn đàn MISA',
	Switchboards: 'Tổng đài MISA',
	NoDataDownload: 'Không có dữ liệu để tải về. Vui lòng kiểm tra điều kiện xuất khẩu!',
	NoDataDownloadFile: 'Không có dữ liệu để tải về. Vui lòng kiểm tra dữ liệu tải xuống!',
	NotHaveName: 'Không có tên',
	NotHaveEmail: 'Không có email',
	NotHavePhoneNumber: 'Không có SDT',
	NotHaveTaxCode: 'Không có MST',
	FullName: 'Họ tên',
	PhoneNumber: 'Điện thoại',
	Company: 'Công ty',
	Address: 'Địa chỉ',
	Version: 'Phiên bản',
	Feedback: 'Góp ý',
	LogOut: 'Đăng xuất',
	AdviseUse: 'Tư vấn sử dụng',
	OtherFeature: 'Tính năng khác',
	AllApp: 'Menu ứng dụng',
	NewFeature: 'Tính năng mới',
	//Bo sung 2/12
	PopularQuestion: 'Câu hỏi thường gặp (F2)',
	Notification: 'Thông báo',
	TitleApp: "MISA meInvoice",
	LicensePayment: 'Giấy phép & Thanh toán',
	ChangePassword: 'Đổi mật khẩu',
	AccountSetting: 'Thiết lập tài khoản',
	SecuritySetting: 'Thiết lập bảo mật',
	IntroductionEarnPoints: 'Giới thiệu nhận điểm',
	Language: lang => `Ngôn ngữ: ${lang}`,
	LanguageDropdown: {
		vi: 'Việt Nam',
		en: 'English'
	},
	Started: 'Bắt đầu sử dụng',
	TermOfService: 'Thỏa thuận sử dụng',
	TermOfPurchase: 'Thỏa thuận mua hàng',
	PrivacyPolicy: 'Chính sách bảo vệ dữ liệu cá nhân',
	TitleTermOfUse: 'Xác nhận chính sách bảo vệ dữ liệu cá nhân và thỏa thuận sử dụng phần mềm',
	TitleTermOfService: 'Xác nhận thỏa thuận sử dụng phần mềm',
	TitlePrivacy: 'Xác nhận chính sách bảo vệ dữ liệu cá nhân',
	LicenseAgreement: 'Thỏa thuận sử dụng phần mềm ',
	and: 'và ',
	ProductMeinvoice: 'sản phẩm MISA meInvoice',
	ContentTermOfUse1: `Theo quy định của pháp luật Việt Nam, MISA bổ sung `,
	ContentTermOfUse2:
		'Bằng việc nhấn Xác nhận, Quý khách đã đồng ý với các điều khoản trong Chính sách quyền riêng tư và Thỏa thuận sử dụng phần mềm của chúng tôi.',
	ContentPrivacy2:
		'Bằng việc nhấn Xác nhận, Quý khách đã đồng ý với các điều khoản trong Chính sách quyền riêng tư của chúng tôi.',
	ContentTermOfService2: `Bằng việc nhấn Xác nhận, Quý khách đã đồng ý với các điều khoản trong Thỏa thuận sử dụng phần mềm của chúng tôi.`,
	CustomerSupport: 'Tổng đài hỗ trợ',
	LicenseWarning: {
		ExpiredInvoiceDate:
			'Thời gian sử dụng và số lượng hóa đơn của quý khách đã hết. Vui lòng gia hạn để không bị gián đoạn công việc.',
		ExpiredDate: 'Thời gian sử dụng của quý khách đã hết. Vui lòng gia hạn để không bị gián đoạn công việc.',
		ExpiredInvoice: 'Số lượng hóa đơn của quý khách đã hết. Vui lòng mua thêm để không bị gián đoạn công việc.',
		ExpiredCommingInvoiceDate:
			'Thời gian sử dụng và số lượng hóa đơn của quý khách sắp hết. Vui lòng gia hạn để không bị gián đoạn công việc.',
		ExpiredComingdDate: numberDate =>
			`Thời gian sử dụng của quý khách chỉ còn ${numberDate} ngày. Vui lòng gia hạn để không bị gián đoạn công việc.`,
		ExpiredCommingInvoice:
			'Số lượng hóa đơn của quý khách sắp hết. Vui lòng mua thêm để không bị gián đoạn công việc.',

		ExpiredInvoiceDateTrial:
			'Thời gian và số lượng hóa đơn dùng thử của quý khách đã hết. Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc.',
		ExpiredDateTrial:
			'Thời gian dùng thử của quý khách đã hết. Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc.',
		ExpiredInvoiceTrial:
			'Số lượng hóa đơn của quý khách đã hết. Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc.',
		ExpiredCommingInvoiceDateTrial:
			'Thời gian và số lượng hóa đơn dùng thử của quý khách sắp hết. Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc.',
		ExpiredComingdDateTrial: numberDate =>
			`Thời gian dùng thử của quý khách còn ${numberDate} ngày. Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc.`,
		ExpiredCommingInvoiceTrial:
			'Số lượng hóa đơn của quý khách sắp hết. Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc.',
		Extend: 'Gia hạn ngay',
		BuyMore: 'Mua thêm ngay',
		Update: 'Nâng cấp ngay',
		Later: 'Để sau'
	},
	SatisfactionAssessment: 'Đánh giá độ hài lòng',
	DownloadSuccess: 'Tải xuống thành công',
	DownloadFail: 'Tải xuống thất bại',
	DownloadSuccessDetail: listMail => `Link tải xuống đã được gửi vào email <strong>${listMail}</strong> vui lòng kiểm tra để tải xuống.`,
	MessageDownloadFail: 'Có lỗi trong quá trình tải xuống, vui lòng tải lại.',
	PrintSuccess: 'In thành công',
	PrintSuccessDetail: listMail => `Link in đã được gửi vào email ${listMail} vui lòng kiểm tra để in.`,
	PrintFail: 'In thất bại',
	MessagePrintFail: 'Có lỗi trong quá trình in, vui lòng in lại.',
	New: 'Mới',
	SupportChannel: 'Kênh hỗ trợ',
	Help: 'Trợ giúp',
	Setting: 'Thiết lập',
	Message: 'Tin nhắn',
	Settings: 'Cài đặt',
	AmisChatTooltip: 'AMIS Chat',
	UserProfile: 'Thông tin tài khoản',
	DirectToMeinvoice: 'Làm việc với MISA meInvoice - Phát hành hóa đơn điện tử',
	QuickFilter: 'Lọc nhanh',
	ActiveStatus: 'Trạng thái hoạt động',
	All: 'Tất cả',
	NotRead: 'Chưa đọc',
	NotiType: 'Loại thông báo',
	MarkAllAsRead: 'Đánh dấu đã đọc tất cả',
	UpdateIdentificationNumber: "Cập nhật CCCD",
	UpdateCCCD: {
		Title: 'Cập nhật Căn cước công dân trên phần mềm',
		OrgHas: `Đơn vị đã`,
		SuccessMessage: identificationNumber => `cập nhật thành công CCCD số ${identificationNumber} trên GPSD phần mềm.`,
		Instructions: `Để kết nối phần mềm <span class='font-bold'>Kế toán</span> với phần mềm <span class='font-bold'>Xử lý hóa đơn</span> lấy hóa đơn về hạch toán đối với <span class='font-bold'>hộ kinh doanh sử dụng CCCD thay cho MST</span>, vui lòng nhấn <span class='font-bold'>Xác nhận</span> để cập nhật thông tin CCCD trên phần mềm.`,
		UpdateWarning: `Trong thời gian cập nhật, bạn <span class='font-bold'>không thể thực hiện bất kỳ tác vụ nào</span><div>trên phần mềm.</div>`,
		LoginChange: identificationNumber => `Sau khi cập nhật CCCD, đơn vị sẽ đăng nhập vào phần mềm bằng CCCD số <span class='font-bold'>${identificationNumber}</span>.`,
		EstimatedTime: `Thời gian cập nhật dự kiến: <span class='font-bold'>5 phút</span> (tính từ thời điểm nhấn <span class='font-bold'>Xác nhận</span>)`,
		ProgressTitle: 'Đang tiến hành cập nhật Căn cước công dân',

		ProgressMessage1: `Trong thời gian cập nhật, bạn <span class='font-bold'>không thể thực hiện bất kỳ tác vụ nào</span> trên phần mềm.`,

		ProgressMessage2: 'Chúng tôi sẽ gửi thông báo đến bạn ngay sau khi hoàn tất việc cập nhật.',
		CompletedMessage: identificationNumber => `Cập nhật CCCD số ${identificationNumber} hoàn tất thành công!`,
		SuccessTitle: 'Hoàn tất cập nhật thông tin Căn cước công dân',
		LoginInstruction: identificationNumber => `<div>Kể từ thời điểm này, đơn vị sẽ đăng nhập vào phần mềm bằng tài khoản</div><div>là số CCCD <span class='font-bold'>${identificationNumber}</span>.</div>`,
		OrganizationInstruction: '<div>Sau khi đăng nhập lại phần mềm, bạn vui lòng cập nhật lại số CCCD trên</div><div> cơ cấu tổ chức của bạn.</div>'
	},
	Close: 'Đóng'
};
